import { swSettings } from "app/common/services/swSettings";

const PURCHASE_GLOBAL_PATH = "/journey/purchase-global";

export const getAccountUrl = (): string => swSettings?.swsites?.login || "https://account.similarweb.com";

export const getShopperUrl = (): string => swSettings?.swsites?.shopper || "https://shopper.similarweb.com";

const getHookWorkspaceResources = () => swSettings?.components?.HookWorkspace?.resources;

const getPackagesPath = (): string => getHookWorkspaceResources()?.NtPackagesUrl || "/journey/packages-global";

const getAddOnPath = (): string => getHookWorkspaceResources()?.NtAddOnPackagesUrl || "/journey/addons-packages-global";

const getSiPackagesPath = (): string => getHookWorkspaceResources()?.SiNtPackagesUrl || "/journey/si/packages-global";

export const getPackageHref = (): string => `${getAccountUrl()}${getPackagesPath()}`;

export const getPackageAddOnHref = (): string => `${getAccountUrl()}${getAddOnPath()}`;

export const getSiPackageHref = (): string => `${getAccountUrl()}${getSiPackagesPath()}`;

export const getPurchaseGlobalHref = (): string => `${getAccountUrl()}${PURCHASE_GLOBAL_PATH}`;

export const getTermsOfUseHref = (): string => "https://www.similarweb.com/corp/legal/terms/";

const getBillingInformationHref = (editMode = false): string =>
    `${getAccountUrl()}/billing-information${editMode ? "?editMode=true" : ""}`;

export const openBillingInformationPage = (editMode = true): void => {
    window.open(getBillingInformationHref(editMode));
};
